var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-tooltip-container",on:{"mouseenter":_vm.showTip,"mouseleave":_vm.showTip}},[_vm._t("tooltip-trigger",function(){return [_c('inline-svg',{staticClass:"info-icon",attrs:{"src":require('@ui-kit/assets/images/general/info.svg')}})]}),_c('div',{staticClass:"info-content-box t4",class:{
    'b': _vm.position === 'bottom',
    't': _vm.position === 'top', 'box-hidden': _vm.visible === false
  }},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }